import React from "react";
const Contact = () => {
    return (
        <div className="screen">
            <strong>VocabLab Contact</strong>
            <p>
            <b>Email:</b> ibrahimwane35@gmail.com<br/><br/>
            </p>
            <br/><br/>
            <strong>COMPANY INFO</strong> 
            <p>
            Contact ibrahimwane35@gmail.com for more information. Copyright © 2024 VocabLab. All rights reserved. <br/><br/>

            ※ Unauthorized copying or theft is prohibited by the Copyright Act (Article 97, Paragraph 5). The copyright of the work belongs to our company and any violation will be punished.<br/>
            </p> 


        </div>
    )
}
export default Contact